module.exports = __webpack_public_path__ + "img/sp_article_3.5dd7a935.jpg";